import { ChangeEvent } from 'react'

import { Button, Card, Input, SearchableSelect } from '..'
import { TSelectOption } from '../shared/searchable-select'

type TChangeBankAccount = {
  readonly providerValue: string
  readonly onChangeProvider: (value: string) => void
  readonly errorProvider?: string
  readonly value: string
  readonly onChangeValue: (value: string) => void
  readonly error?: string
  readonly buttonLabel: string
  readonly isButtonDisabled?: boolean
  readonly bankOptions: TSelectOption[]
}

export default function ChangeBankAccount({
  providerValue,
  onChangeProvider,
  errorProvider,
  value,
  onChangeValue,
  error,
  buttonLabel,
  isButtonDisabled = false,
  bankOptions,
}: TChangeBankAccount) {
  const handleChangeInput = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChangeValue(e.target.value)
  }

  return (
    <Card>
      <div className='flex flex-col gap-5'>
        <SearchableSelect
          caption='Bank Name'
          placeholder='Select Bank Name'
          options={bankOptions}
          value={providerValue}
          onChange={onChangeProvider}
          error={errorProvider}
        />
        <Input
          type='number'
          caption='Account Number'
          label='Input Account Number'
          value={value}
          onChange={handleChangeInput}
          error={error}
        />
        <Button
          type='submit'
          variant='contained'
          color='primary'
          disabled={isButtonDisabled}
          aria-label='Save New Account'
        >
          {buttonLabel}
        </Button>
      </div>
    </Card>
  )
}
